/*
 *   File : manage-basket.jsx
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations :
 *   Version : 1.0.0
 */

import React, { useEffect, useState } from "react";
import { PrimaryButton } from "../../Components/Cta";
import { BasketCard } from "../../Components/Card";
import { useNavigate } from "react-router-dom";
import { APIService } from "../../Service";
import Loader from "../../Components/Other/loader";
import { CustomTab, EmptyScreen } from "../../Components/Other";
import MappedBaskets from "./Helper/mapped-baksets";

const basketColors = [
  {
    bgColor: "e-bg-magnolia",
    borderColor: "e-border-1px-languid-lavender",
  },
  {
    bgColor: "e-bg-alice-blue",
    borderColor: "e-border-1px-soap",
  },
  {
    bgColor: "e-bg-azure",
    borderColor: "e-border-1px-chinese-white",
  },
  {
    bgColor: "e-bg-ivory",
    borderColor: "e-border-1px-dirty-white",
  },
  {
    bgColor: "e-bg-snow",
    borderColor: "e-border-1px-rose",
  },
];
const TAB_DATA = [
  { id: 1, name: "Pre-defined baskets", label: "Pre-defined baskets" },
  {
    id: 2,
    name: "Mapped Basket against risk & tenure",
    label: "Mapped Basket against risk & tenure",
  },
];

export default function ManageBasket() {
  const navigate = useNavigate();
  const [baskets, setBaskets] = useState([]);
  const [loader, setLoader] = useState(false);
  const [emptyScreen, setEmptyScreen] = useState(false);
  const [tab, setTab] = useState(TAB_DATA[0].id);

  useEffect(() => {
    setLoader(true);
    _getBaskets();
  }, []);

  const _getBaskets = () => {
    const is_post = false;
    APIService(is_post, "manage-basket/list")
      .then((response) => {
        if (response.status_code === 200) {
          setBaskets(
            response.data?.map((elem) => ({ ...elem, is_recommended: false })),
          );
        } else {
          setEmptyScreen(true);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const _handleTabChange = (id) => {
    setTab(id);
  };
  return (
    <div className="row px-3">
      <div className="col-12 e-pt-20px">
        <div className="row">
          <div className="col-12">
            <div className="e-customer-tab d-flex flex-nowrap justify-content-between align-items-center e-border-1px-bottom-magnolia-light ">
              <div className="d-flex column-gap-2">
                {TAB_DATA.map((data, index) => (
                  <CustomTab
                    key={index}
                    type={1}
                    borderRadius="border-radius-4"
                    tabData={data}
                    tabIndex={tab}
                    background="bg-white"
                    handleChange={() => _handleTabChange(data.id)}
                  />
                ))}
              </div>
              <PrimaryButton
                ClassName="e-border-radius-pill e-font-weight-500 py-2 e-font-14 e-bg-blue-violet text-white e-primary-font-poppins mb-2"
                name="Create Basket"
                onPress={() => navigate("add")}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-12">
        {loader ? (
          <div className="d-flex min-vh-100 justify-content-center align-items-center">
            <Loader width={30} />
          </div>
        ) : emptyScreen ? (
          <EmptyScreen message="Data Not Found" width="200px" />
        ) : tab === 1 ? (
          <div className="row row-cols-xl-3 row-cols-md-2 row-cols-1 e-pt-20px row-gap-3">
            {baskets.map((item, index) => {
              const color = basketColors[index % basketColors.length];
              return (
                <div className="col d-flex" key={index}>
                  <BasketCard
                    title={item.name}
                    img={item.image}
                    content={item.description}
                    returns={`${item.return_percentage} (${item.return_year})`}
                    BgColor={item.color}
                    borderColor={color.borderColor}
                    type={item.is_recommended ? 3 : 1}
                    badges={item.features}
                    returnYear={item?.return_year || "3Y"}
                    handleView={() =>
                      navigate(`/manage-basket/detail/${item.basket_style_id}`)
                    }
                  />
                </div>
              );
            })}
          </div>
        ) : (
          <MappedBaskets basketData={baskets} basketColors={basketColors} />
        )}
      </div>
    </div>
  );
}
